/**
 * The app's Tabs: the basis primitives, with the app's `TabsTrigger` below.
 * The basis file is untouched; `@/components/ui` exports this trigger, never
 * the basis one (SA-1123's `TooltipContent` precedent).
 */
import type { ComponentProps } from 'react'
import { TabsTrigger as BasisTabsTrigger } from './basis/tabs'
import { cn } from '@/utils'

export { Tabs, TabsList, TabsContent } from './basis/tabs'

/**
 * SA-1132: the selected tab is a raised card on the muted track — the card
 * shade plus a hairline. The basis selected shade is `bg-background`, which is
 * the page ground since SA-1059 (neutral-50 in light) and all but vanished on
 * the neutral-100 track. `cn` is tailwind-merge, so this replaces the basis
 * shade; the basis `shadow-sm`, focus ring, text colors and the transparent
 * resting border (the same width, so selecting moves nothing) stay, and a
 * caller's own class still comes last and wins. Never a filled primary pill
 * (SA-1123).
 */
export const TAB_SELECTED_CLASS = 'data-[state=active]:bg-card data-[state=active]:border-border'

export function TabsTrigger({ className, ...props }: ComponentProps<typeof BasisTabsTrigger>) {
  return <BasisTabsTrigger className={cn(TAB_SELECTED_CLASS, className)} {...props} />
}
